import * as actionTypes from "../actions/actionTypes";
import { updateObject } from "../../shared/utility";

const initialState = {
  drexiOtp: "",
  loading: false,
  error: false,
  errorMessage: "",
};
const drexiLoginReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_DREXI_SESSION_ID_STARTED:
      return updateObject(state, {
        drexiOtp: "",
        loading: true,
        error: false,
        errorMessage: "",
      });
    case actionTypes.GET_DREXI_SESSION_ID_SUCCESS:
      return updateObject(state, {
        drexiOtp: action.drexiOtp,
        loading: false,
        error: false,
        errorMessage: "",
      });
    case actionTypes.GET_DREXI_SESSION_ID_FAILED:
      return updateObject(state, {
        drexiOtp: "",
        loading: false,
        error: true,
        errorMessage: action.errorMessage,
      });
    default:
      return state;
  }
};

export default drexiLoginReducer;
